$(document).ready(function () {
  // Loader
  setTimeout(function () {
    $('#loader').fadeOut();
  }, 200);

  // Device Detection
  const b = $('body'),
    isTouchDevice = () => {
      return (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      );
    };

  function init() {
    document.documentElement.style.cssText = `
      --h: ${window.innerHeight}px;
    `;
  }
  init();

  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
      navigator.userAgent || navigator.vendor || window.opera
    ) ||
    isTouchDevice()
  ) {
    // If device
    b.addClass('mobile');

    // Pseudoclass :active on devices
    document.addEventListener('touchstart', function () {}, { passive: true });

    // Resize Functions
    window.addEventListener('orientationchange', function () {
      setTimeout(function () {
        init();
      }, 50);
    });
  } else {
    // If Desktop
    b.addClass('desktop');

    // Resize Functions
    window.onresize = function () {
      init();
    };
  }

  // LAZY LOAD
  var L = [].slice.call(document.querySelectorAll('.lazy'));
  if ('IntersectionObserver' in window) {
    let o = new IntersectionObserver(function (E, observer) {
      E.forEach(function (e) {
        if (e.isIntersecting) {
          let l = e.target;
          if (l.tagName == 'IMG') {
            l.src = l.dataset.src;
          }
          if (l.tagName == 'VIDEO') {
            var P = l.play();
            if (P !== undefined) {
              P.catch((error) => {
                l.controls = true;
                l.classList.add('no-autoplay');
              });
            }
          }
          l.classList.remove('lazy');
          o.unobserve(l);
        }
      });
    });
    L.forEach(function (l) {
      o.observe(l);
    });
  }

  // Viewport Height
  function height() {
    document.documentElement.style.cssText = `
      --h: ${window.innerHeight}px;
      --menu: ${$('.menus').innerHeight()}px;
      --footer: ${$('.footer').innerHeight()}px;
    `;
  }
  function onLoadandResize() {
    height();
  }
  window.addEventListener('resize', onLoadandResize);
  $('.menu').on('resize', onLoadandResize);
  $('.footer').on('resize', onLoadandResize);
  onLoadandResize();

  // Mini Cart
  $('#cart-trigger').click(function () {
    $('#mini-cart').fadeToggle(200).css('display', 'grid');
  });

  $('#product-add').click(function () {
    $('#mini-cart').fadeToggle(200).css('display', 'grid');
  });

  $('.close-cart').click(function () {
    $('#mini-cart').fadeOut(200);
  });

  // Mobile Menu
  $('#menu-trigger').click(function () {
    $('#menu-desktop').slideToggle().css('display', 'grid');
    $(header).toggleClass('whitey');
  });

  $('.mobile-menu-toggle').click(function () {
    $('.filters').slideToggle().css('display', 'grid');
  });

  // Filters movement on resize
  function handleWindowResize() {
    if ($(window).width() < 834) {
      $('#filters').appendTo('#menu-desktop');
    } else {
      $('#filters').prependTo('#index');
    }
  }

  $(window).on('resize', handleWindowResize);
  handleWindowResize();
});
